<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section>
                <div class="text-h6">
                    Renew your {{ entityTypeName }} "{{ entityName }}"
                </div>
                <q-separator/>
            </q-card-section>

            <q-card-section class="q-my-none">
                Extend the expiration date of your {{ entityTypeName }} "{{ entityName }}"
                <span v-if="isSubdomain">
                    and your Memo Links using it:<br>
                    <i>https://{{ entityName }}.{{ domain }}</i>
                </span>
            </q-card-section>

            <template v-if="!isSubdomain && props.entity.subdomain !== null">
                <q-card-section class="q-my-none">
                    To renew Memo Link with Domain you should renew Domain expiration date
                    on <router-link :to="{name:'subdomains.list'}">My Domains page</router-link>
                </q-card-section>
            </template>
            <template v-else>
                <q-card-section v-if="!isSubdomain || isSubdomain && props.entity.is_free" class="q-my-none">
                    <q-btn
                        color="primary"
                        class="q-my-md"
                        @click="onOKClick"
                        push no-caps>
                        Renew {{ entityName }}
                    </q-btn>
                    <br>
                    Renew for free {{ daysToMonths(extendMonthsSubdomain) }} <strong>ONLY</strong>
                    your {{ entityTypeName }} {{ entityName }}
                    <span v-if="props.type === 'subdomain'">
                    and your Memo Links using it<br>
                </span>
                </q-card-section>
            </template>

            <q-card-actions align="right" class="q-px-md">
                <q-btn color="grey" label="Cancel" @click="onDialogCancel" push/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { useStore } from 'vuex'
import { useDialogPluginComponent } from 'quasar'
import { computed, inject } from 'vue'
import {daysToMonths} from '../helpers'

const props = defineProps(['type', 'entity'])
const store = useStore()
const domain = inject('appDomain')

const isSubdomain = props.type === 'subdomain'

const entityTypeName = isSubdomain ? 'Domain' : 'Memo Link'
const entityName = isSubdomain ? props.entity.name.toUpperCase() : props.entity.words.join(' ')

const limits = computed(() => store.getters.getLimits)
const extendMonthsSubdomain = computed(() => parseInt(limits?.value?.getSubdomainExpiration()?.value))

defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

function onOKClick () {
    onDialogOK()
}
</script>

<style lang="sass" scoped>
body.screen--xl, body.screen--lg
    .q-dialog-plugin
        width: 900px

</style>
